import { AppProviders } from "./AppProvider";
import AppRouterProvider from "../routes/AppRouterProvider";

// Side-effect import: registers every per-industry lead filter section into
// the in-process registry consumed by `leadFilter.tsx`. Must run once before
// the lead drawer mounts.
import "@/features/leads/components/leadFilter/registry/boot";

export default function App() {
  return (
    <AppProviders>
      <AppRouterProvider />
    </AppProviders>
  );
}
